import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import useStore from "../../useStore";

function AccountBalance() {
    const{balance} = useStore()
    return (
      <Card
        sx={{
          maxWidth: 400,

          borderRadius: 2,
          boxShadow: 3,
          padding: 2,
          backgroundColor: "#f5f5f5",
        }}
      >
        <CardContent>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" color="primary" fontWeight="bold">
              Company Balance
            </Typography>
            <AccountBalanceWalletIcon fontSize="large" color="primary" />
          </Box>
          <Typography
            variant="h4"
            color="text.secondary"
            fontWeight="bold"
            sx={{ mt: 2 }}
          >
            ₹{balance}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Updated: Today
          </Typography>
        </CardContent>
      </Card>
    );
}

export default AccountBalance;
